"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _immutable = require("immutable");

var _fluxActions = require("flux-actions");

var _modalActions = require("../actions/interactions/modalActions");

var _handleActions;

var initialState = (0, _immutable.fromJS)({
  ampPreviewModalOpen: false,
  newBlogModalOpen: false,
  deleteBlogModalOpen: false,
  dateFormatHelpPanelOpen: false,
  customDateTimeFormatCreatorModalOpen: false,
  customMonthFormatCreatorModalOpen: false,
  stylesheetSelectModalOpen: false
});

var _default = (0, _fluxActions.handleActions)((_handleActions = {}, (0, _defineProperty2.default)(_handleActions, _modalActions.ModalActionTypes.OPEN_AMP_PREVIEW_MODAL, function (state) {
  return state.set('ampPreviewModalOpen', true);
}), (0, _defineProperty2.default)(_handleActions, _modalActions.ModalActionTypes.OPEN_NEW_BLOG_MODAL, function (state) {
  return state.set('newBlogModalOpen', true);
}), (0, _defineProperty2.default)(_handleActions, _modalActions.ModalActionTypes.OPEN_DELETE_BLOG_MODAL, function (state) {
  return state.set('deleteBlogModalOpen', true);
}), (0, _defineProperty2.default)(_handleActions, _modalActions.ModalActionTypes.OPEN_CUSTOM_DATE_TIME_FORMAT_CREATOR_MODAL, function (state) {
  return state.set('customDateTimeFormatCreatorModalOpen', true);
}), (0, _defineProperty2.default)(_handleActions, _modalActions.ModalActionTypes.OPEN_CUSTOM_MONTH_FORMAT_CREATOR_MODAL, function (state) {
  return state.set('customMonthFormatCreatorModalOpen', true);
}), (0, _defineProperty2.default)(_handleActions, _modalActions.ModalActionTypes.OPEN_DATE_FORMAT_HELP_PANEL, function (state) {
  return state.set('dateFormatHelpPanelOpen', true);
}), (0, _defineProperty2.default)(_handleActions, _modalActions.ModalActionTypes.OPEN_STYLESHEET_SELECT_MODAL, function (state) {
  return state.set('stylesheetSelectModalOpen', true);
}), (0, _defineProperty2.default)(_handleActions, _modalActions.ModalActionTypes.CLOSE_MODAL, function (state) {
  return state.merge({
    ampPreviewModalOpen: false,
    newBlogModalOpen: false,
    deleteBlogModalOpen: false,
    customDateTimeFormatCreatorModalOpen: false,
    customMonthFormatCreatorModalOpen: false,
    dateFormatHelpPanelOpen: false,
    stylesheetSelectModalOpen: false
  });
}), _handleActions), initialState);

exports.default = _default;
module.exports = exports.default;